//
// Update prices for new currency.
// Items in the cart not listed in pricing don't support
// this currency zone.
//
const updateCurrency = (state, pricing, currencyCode, setMessage) => {
    const filtered = state.filter(product => pricing[product.skuVariant] !== undefined);
    const dropCount = state.length - filtered.length;
    let msg;
    if (dropCount === filtered.length) {
        msg = `The ${dropCount} ${filtered.length > 1 ? 'items' : 'item'} in your cart ${filtered.length > 1 ? 'aren\'t available' : 'isn\'t available'} for ${currencyCode} region. Visit the shop for available products.`;
    } else if (dropCount > 0) {
        msg = `${dropCount} ${dropCount > 1 ? 'cart items aren\'t' : 'cart item isn\'t'} available for ${currencyCode} region. Visit the shop for available products.`;
    } else {
        msg = `We changed ${filtered.length} ${filtered.length > 1 ? 'items in your cart' : 'item in your cart'} to ${currencyCode} pricing. Please check the cart.`;
    }
    setMessage({note: msg, duration: 10000});
    return state.filter(product => pricing[product.skuVariant] !== undefined).map(product => { // products available for currency; see store-currency
        return {...product, price: pricing[product.skuVariant], currency: currencyCode};
    });
}

// 
// Here skuVariant is GVY000001-24x36_in.poster.gto from CartItem in shopping-cart.
//
const updateQuantity = (state, skuVariant, quantity) => {
    return state.map(product => {
        if (product.skuVariant === skuVariant) {
            return { ...product, quantity: quantity };
        } else {
            return product;
        }
    });
}

//
// See CartReducer for state.
//
const addProduct = (state, product) => {
    const foundProduct = state.find(p => p.skuVariant === product.skuVariant);
    if (foundProduct) {
        const quantity = parseInt(foundProduct.quantity, 10) + 1;
        return updateQuantity(state, product.skuVariant, quantity);
    } else {
        const productData = { ...product, skuVariant: product.skuVariant };
        return [...state, productData];
    }
}

/**
 * @param {*} state This is the actual cart (an array of items), allowing items.length, items.map(item => item.skuVariant) etc.
 * @param {*} action A proxy to reducer via ADD_TO_CART using cartDispatch({action.type, data}).
 */
const CartReducer = (state, action) => {
    switch (action.type) {
        case 'ADD_TO_CART':
            return addProduct(state, action.product);
        case 'UPDATE_QUANTITY': {
            const { skuVariant, quantity } = action;
            return updateQuantity(state, skuVariant, quantity);
        }
        case 'UPDATE_CURRENCY': {
            const { pricing, currencyCode, setMessage } = action;
            return updateCurrency(state, pricing, currencyCode, setMessage); // drop items not available for currency
        }
        case 'REMOVE_FROM_CART': {
            const { skuVariant } = action;
            return state.filter(product => product.skuVariant !== skuVariant);
        }
        case 'REFRESH_CART': { // local storage update in second browser tab
            const { products } = action;
            return products;
        }
        case 'CLEAR_CART':
            return [];
        case 'SET_CART':
            return action.cart;
        default:
            return state;
    }
}

export { CartReducer as default };